import React from 'react';
import { SharedStateContext } from './SharedState';

function commonContextsWrapper(Component) {
    return function(props) {
        const sharedState = React.useContext(SharedStateContext);
        return <Component {...props} sharedState={sharedState}/>
    };
};

export default commonContextsWrapper;
